import React, { useState } from 'react';
import {
    useCreate,
    // useUpdate,
    useRefresh,
    useNotify,
    useGetIdentity,
    useResourceContext
} from 'react-admin';
import { TextField as TextInput, Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

// import { StatusSelector } from './StatusSelector';

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(1),
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: theme.spacing(1),
    },
    small: {
        marginRight: '1em',
        '& .MuiFilledInput-input': {
            paddingTop: 10,
        },
    },
}));

export const NewNote = ({
    showStatus,
    reference,
    foreignKeyMapping,
    record
}) => {
    const classes = useStyles();
    // const record = useRecordContext();
    const resource = useResourceContext();
    const [text, setText] = useState('');
    const [status] = useState(record && record.status);
    const [create, { loading }] = useCreate();
    const refresh = useRefresh();
    const notify = useNotify();
    const { identity } = useGetIdentity();
    if (!record || !identity) return null;

    const handleSubmit = (event) => {
        event.preventDefault();
        notify('Creating note...');
        const data = {
            [foreignKeyMapping]: record.id,
            user_id: identity.id,
            text: text
        };
        if (showStatus) {
            data.status = status;
        }
        // update(
        //     reference,
        //     record.id,
        //     {
        //         last_seen: date,
        //         status,
        //         nb_notes: record.nb_notes + 1,
        //     },
        //     record
        // );
        create(resource, { data: data }, {
            onSuccess: () => {
                setText('');
                notify('Note added successfully');
                refresh();
            },
            onError: (err) => {
                notify(`Note creation failed: ${err}`);
            }
        });
        return false;
    };

    return (
        <div className={classes.root}>
            <form onSubmit={handleSubmit}>
                <TextInput
                    label="Add a note"
                    variant="filled"
                    size="small"
                    fullWidth
                    multiline
                    value={text}
                    onChange={(event) =>
                        setText(event.target.value)
                    }
                    rows={3}
                />
                <div className={classes.toolbar}>
                    <span>
                        {text ? (
                            <>
                                {/* {showStatus && (
                                    <StatusSelector
                                        status={status}
                                        setStatus={setStatus}
                                        className={classes.small}
                                    />
                                )} */}
                                {/* <TextInput
                                    type="datetime-local"
                                    variant="filled"
                                    size="small"
                                    value={date}
                                    onChange={(
                                        event
                                    ) => {
                                        setDate(event.target.value);
                                    }}
                                    className={classes.small}
                                /> */}
                            </>
                        ) : null}
                    </span>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={!text || loading}
                    >
                        Add this note
                    </Button>
                </div>
            </form>
        </div>
    );
};
